<span [ngClass]="{'p-float-label' : isShowFloatLabel}">
    <p-inputMask [type]="inputType" [id]="id || placeholder" styleClass="form-control-input" [mask]="mask"
        [unmask]="unmask" [slotChar]="slotChar" [ngModel]="value" (ngModelChange)="updateValue($event)"
        (onBlur)="onTouch();" (onKeydown)="handleEmptySpace($event);"
        [placeholder]="isShowFloatLabel ? '' : placeholder"></p-inputMask>
    <label *ngIf="isShowFloatLabel" [for]="id || placeholder">{{placeholder}}</label>
</span>